export default {
  locations: {
    title: 'Settings',
    list: {
      columns: {
        locationName: 'Location name',
        cityAndState: 'City and State',
        address: 'Address',
        phone: 'Phone'
      }
    }
  },
  manageTeam: {
    title: 'Settings',
    list: {
      columns: {
        user: 'User',
        status: 'Status',
        role: 'Role'
      }
    }
  }
};
